import { action } from "satcheljs";
import { IShiftEntity } from "sh-models";
import { Moment } from 'moment';
import { SchedulesViewStateStore } from "../store/schema/SchedulesViewStateStore";
import { IPreviewSchedulePageStore } from "../../../previewSchedulePage";

const setupConflicts = action(
    "SETUP_CONFLICTS",
    (
        viewState: SchedulesViewStateStore | IPreviewSchedulePageStore,
        shiftsAdded: IShiftEntity[],
        shiftsDeleted: IShiftEntity[],
        shiftsUpdated: IShiftEntity[],
        fetchStartTime: Moment,
        fetchEndTime: Moment,
        forceCalculate?: boolean,
        isProgressiveRenderingMode?: boolean,
        userSettingsEnabled?: boolean
    ) => ({
        viewState,
        shiftsAdded: shiftsAdded || [],
        shiftsDeleted: shiftsDeleted || [],
        shiftsUpdated: shiftsUpdated || [],
        fetchStartTime: fetchStartTime,
        fetchEndTime: fetchEndTime,
        forceCalculate: forceCalculate,
        isProgressiveRenderingMode: isProgressiveRenderingMode,
        userSettingsEnabled: userSettingsEnabled
    })
);

export default setupConflicts;